/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetTransportsBrandsQueryResponse, GetTransportsBrandsQueryParams, GetTransportsBrands400 } from '../entities/GetTransportsBrands'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetTransportsBrandsUrl() {
  return `/transports/brands` as const
}

/**
 * @description Get all transport brands
 * @summary Get all transport brands
 * {@link /transports/brands}
 */
export async function getTransportsBrands(params?: GetTransportsBrandsQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetTransportsBrandsQueryResponse, ResponseErrorConfig<GetTransportsBrands400>, unknown>({
    method: 'GET',
    url: getGetTransportsBrandsUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}